const labels = {
    es:{
        testUnusedKey: "Please do not translate me. I am just a test key",
        testEnOnlyKey: "Please do not translate me. I am just a test key",
        literal:{
            invalidPromoCode: "Código promocional inválido",
            promoCodeApplied: "Código aplicado con éxito",
            availableIn: "Disponible en {{timeToStart}}",
            messageFrom: "Mensaje de {{organizationTitle}}",
            sending: "Enviando...",
            signUp: "Regístrate",
            and_sc: "y",
            reset: "Restablecer",
            signIn: "Iniciar sesión",
            spanish: "Español",
            name: "Nombre",
            email: "Correo electrónico",
            password: "Contraseña",
            newPassword: "Nueva contraseña",
            confirmPassword: "Confirmar contraseña",
            redeem: "Canjear",
            reveal: "Revelar",
            redeemed: "Canjeado",
            claim: "Reclamar",
            available: "Disponible",
            contract: "Contrato",
            seeDescription: "Ver descripción",
            redeemBy: "Canjear antes de",
            continue: "Continuar",
            submitChanges: "Guardar cambios",
            requestInvoice: "Solicitar factura",
            requestInvoiceChanges: "Solicitar cambios en la factura",
            invoiceSent: "Recibo enviado",
            completed: "Completado",
            cancelled: "Cancelado",
            createdAt: "Creado el",
            quantity: "Cantidad",
            paid: "Pagado",
            seeDetails: "Ver detalles",
            address: "Dirección",
            vat: "IVA",
            seeMembershipTiers: "Ver niveles de membresía",
            privacyPolicy: "Política de privacidad",
            termsAndConditions: "Términos y condiciones",
            connect: "Conectar",
            seeLess: "Ver menos",
            seeMore: "Ver más",
            free: "Gratis",
            join: "Unirse",
            subscribe: "Suscribirse",
            buy: "Comprar",
            price: "Precio",
            upgradingSubscription: "Actualizando suscripción",
            profile: "Perfil",
            editProfile: "Editar perfil",
            logout: "Cerrar sesión",
            limitedSupply: "Existencias limitadas",
            expirationDate: "Fecha de caducidad",
            description: "Descripción",
            claimYour: "Reclama tu",
            pricing: "Precios",
            no: "No",
            yes: "Sí",
            showOnChain: "Mostrar en cadena",
            claimOnChain: "Reclamar en cadena",
            share: "Compartir",
            downloadImage: "Descargar imagen",
            downloadPDF: "Descargar PDF",
            manageSubscription: "Gestionar suscripción",
            error: "Error",
            seeCollection: "Ver colección",
            buyNow: "Comprar ahora",
            addToCart: "Añadir al carrito",
            subtotal: "Subtotal",
            billingDetails: "Datos de facturación",
            recipientDetails: "Datos del destinatario",
            completePayment: "Completar pago",
            paymentConfirmation: "Confirmación de pago",
            giftSent: "Regalo enviado",
            next: "Siguiente", //context checkout stepper
            of_sc: "de", //context checkout stepper
            paymentMethods: "Métodos de pago",
            phoneNumber: "Número de teléfono",
            proceed: "Proceder",
            city: "Ciudad",
            postCode: "Código postal",
            billingAddress: "Dirección de facturación",
            contactDetails: "Datos de contacto",
            personalDetails: "Datos personales",
            personalOrCompanyDetails: "Datos personales o de empresa",
            newsletterPreferences: "Preferencias de correo electrónico",
            connectedAccounts: "Cuentas conectadas",
            clickHere: "Haz clic aquí",
            from: "Desde",
            to: "Hasta",
            upgradeMembership: "Actualizar membresía",
            members_sc: "miembros",
            none_sc: "ninguno",
            seeMemberships: "Ver membresías",
            once_sc: "una vez",
            times_sc: "veces", //vezes
            store: "Tienda",
            after: "después",
            renewsOn: "Se renueva el",
            expiresOn: "Caduca el",
            downgrading_sc: "bajando de categoría",
            memberships: "Membresías",
            monthly: "Mensual",
            quarterly: "Trimestral",
            yearly: "Anual",
            orderSummary: "Resumen del pedido",
            payment_sc: "pago",
            joinNow: "Unirse ahora",
            submit: "Enviar",
            view: "Ver",
            revealSoon: "Revelar pronto",
            claiming: "Reclamando",
            settings: "Configuración",
            firstName: "Nombre",
            lastName: "Apellido",
            portuguese: "Portugués",
            english: "Inglés",
            update: "Actualizar",
            walletAddress: "Dirección de la cartera",
            preferences: "Preferencias",
            membershipPasses: "Pases de membresía",
            digitalCollectibles: "Coleccionables digitales",
            congratulations: "Felicidades",
            disconnectWallet: "Desconectar cartera",
            showAll: "Mostrar todo",
            filterBy: "Filtrar por",
            organization: "Organización",
            you: "Tú",
            other_sc: "otro",
            like: "Me gusta",
            comment: "Comentar",
            liked: "Te ha gustado",
            billingHistory: "Historial de facturación",
            help: "Ayuda",
            reactivate: "Reactivar",
            downgrading: "Bajando de categoría",
            toFree: "a Gratis",
            unclaimed: "no reclamado",
            viewNFT: "Ver NFT",
            about: "Inicio",
            newsletter: "Novedades",
            more: "Más",
            privateLink: "Enlace privado",
            receive: "Recibir",
            points_sc: "puntos",
            loadMore: "Cargar más",
            seeLatest: "Ver lo último",
            country: "País",
            soldOut: "Agotado",
            limitReached: "Límite alcanzado",
            selectOption: "Selecciona una opción",
            chooseOption: "Elige {{- options}}",
            variantSoldOut: "Esta opción está agotada",
            viewMore: "Ver más",
            viewAll: "Ver todo",
            claimWithNFT: "Reclamar con NFT",
            discount: "Descuento",
            cancel: "Cancelar",
            goTo: "Ir al Club",
            welcome: "Bienvenido",
            buyTickets: "Comprar entradas",
            save: "Guardar",
            unsubscribe: "Cancelar suscripción",
            events: "Eventos",
            tickets: "Entradas",
            merch: "Merch",
            upcoming: "Próximos",
            past: "Pasados",
            here: "aquí",
            members: "Miembros",
            freeEntrance: "Entrada gratuita",
            ticketDetails: "Detalles de la entrada",
            location: "Ubicación",
            secretVenueFallback: "La ubicación se ha mantenido en secreto a propósito.",
            reason: "Motivo",
            close: "Cerrar",
            applicationFee: "Tarifas de servicio",
            confirmTransaction: "Confirmar pago",
            now: "Ahora",
            confirm: "Confirmar",
            card: "Tarjeta",
            filter: "Filtrar",
            addPromoCode: "Añadir código promocional",
            tickets_sc: "entradas",
            products_sc: "productos",
            ticket_sc: "entrada",
            product_sc: "producto",
            manageClub: "Gestionar Club",
            unavailable: "No disponible",
        },
        errors:{
            appCrashed: "Algo salió mal. Por favor, recarga la página e inténtalo de nuevo.",
            appCrashedReload: "Recargar página",
            unableToCreateEupagoOrder: "No se pudo crear el pedido. Inténtalo de nuevo o elige un método de pago diferente",
            failedToFindOrderResult: "Algo salió mal. Por favor, contacta con el administrador del club",
            invalidTicketEmail: "Proporciona un correo electrónico válido para la entrada",
            cartEventMismatch: "Tu carrito tiene entradas para otro evento. Elimínalas antes de añadir esta entrada.",
            pickAnOption: "Por favor, selecciona primero una opción.",
            nameMissing: "Dinos tu nombre",
            emailMissing: "Proporciona una dirección de correo electrónico válida",
            passwordMissing: "Proporciona una contraseña válida",
            passwordsDontMatch: "Las contraseñas no coinciden",
            dataAgreementMissing: "Lee y acepta nuestros términos y condiciones",
            countryMissing: "Dinos tu país",
            postalCodeMissing: "Dinos tu código postal",
            addressMissing: "Dinos tu dirección",
            cityMissing: "Dinos tu ciudad",
            notEligiblePerk: "No cumples los criterios para canjear este beneficio. Si crees que se trata de un error, contacta con la organización que lo emitió",
            default: "Algo salió mal, inténtalo de nuevo. Si el problema persiste, contacta con el administrador",
            userExists: "Ya existe una cuenta con el correo electrónico proporcionado. Utiliza un correo electrónico diferente o inicia sesión con la cuenta existente.",
            emailValidationFailed: "Hubo un error al validar tu dirección de correo electrónico. Inténtalo de nuevo.",
            giftEmailMissing: "Dinos la dirección de correo electrónico de la persona a la que quieres enviar este {{rewardCategoryLabel}}.",
            giftNameMissing: "Dinos el nombre de la persona a la que quieres enviar este {{rewardCategoryLabel}}.",
            giftSenderEmailMissing: "Dinos tu dirección de correo electrónico.",
            redeemedMax: "Has canjeado este beneficio el número máximo de veces.",
            manualSubscription: "Tu suscripción activa solo puede ser modificada manualmente por uno de los administradores de tu club. Ponte en contacto si necesitas ayuda.",
            nftSubscription: "Tu suscripción activa solo puede ser modificada manualmente por uno de los administradores de tu club. Ponte en contacto si necesitas ayuda.",
            passAlreadyIssued: "Ya tienes este pase.",
            unableToValidateOnchain: "El coleccionable digital asociado a esta oferta se reclamó en cadena como NFT. Desafortunadamente, la verificación de NFT en cadena aún no está disponible, pero nuestro equipo está trabajando para lanzarla pronto. Nos pondremos en contacto contigo tan pronto como esté lista, para que puedas canjear tu oferta.",
            commentEmpty: "Los comentarios no pueden estar vacíos",
            alreadyIssuedMax: "Ya se te ha emitido este coleccionable digital el número máximo de veces.",
            notEligible: "Tu cuenta no es elegible para reclamar este coleccionable digital. Contacta con la organización si crees que esto no es correcto.",
            privateClaim: "*Tu correo electrónico, o cuenta de Membrz Club, debe ser elegible para reclamar este coleccionable digital. Contacta con la organización si no puedes reclamarlo.",
            unavailable: "Este coleccionable digital ya no está disponible.",
            notFound: "No encontrado",
            unableToValidateCredentials: "No se pudieron validar las credenciales",
            unableToValidateSignature: "No se pudo validar la firma",
            noPaymentProviders: "No se pudo cargar un proveedor de pagos válido. Inténtalo de nuevo más tarde.",
            stripeNotConnected: "No se pudo conectar a Stripe. Inténtalo de nuevo más tarde.",
            pleaseRefresh: "Actualiza la página e inténtalo de nuevo.",
            fieldMissing: "Campo obligatorio: {{field}}",
            reachedMaxAmount: "Cantidad actualizada a {{maxAmount}} debido a que se alcanzó el máximo permitido.",
            entitledToCoupon: "Tienes derecho a un descuento para miembros, que ya ha sido aplicado.",
        },
        tcLabel:{
            agreement: "Acepto los",
        },
        //containers
        account:{
            forgotPassword:{
                errorEmailMissing: "Proporciona una dirección de correo electrónico válida",
                requestInstructions: "Enviar instrucciones de restablecimiento",
                resetInstructions: "Se envió un correo electrónico con instrucciones a la dirección de correo electrónico que proporcionaste. Revisa tu correo electrónico.",
                resumingOrgSignupInstructions: "Establece una contraseña para terminar de crear {{title}}. Te enviaremos un enlace por correo para elegir una.",
            },
            invite:{
                header: "{{organizationName}} te invitó a",
                content: "Regístrate para coleccionar insignias y certificados NFT para este {{category}}",
            },
            login:{
                pageTitle: "¡Inicia sesión para acceder a tu Club de Miembros!",
                button: "Iniciar sesión",
            },
            switchLink:{
                noClubQuestion: "¿Quieres tener tu propio club? ",
                signUpCall: "Créalo aquí",
                hasAccountQuestion: "¿Ya tienes una cuenta? ",
                signInCall: "Inicia sesión aquí",
            },
            building: {
                title: "Configurando tu perfil",
                lookingUpEvents: "Buscando tus próximos eventos",
                checkingMicLevels: "Comprobando niveles del micrófono",
                paintingProfile: "Pintando tu perfil del Club",
                writingSetlist: "Escribiendo tu lista de canciones",
                lastSoundcheck: "Casi listo, lo prometo. Esta es la última prueba de sonido, quizás",
                warmingUpCrowd: "Calentando al público",
            },
            resetPassword:{
                newUserPageTitle: "Restablece tu contraseña",
                newUserPageDescription: "Introduce tu nueva contraseña.",
            },
            common:{
                forgotPasswordAndResetPasswordPageTitle: "¿Olvidaste tu contraseña?",
                forgotPasswordAndResetPasswordPageDescription: "Le pasa a los mejores. Te ayudaremos a restablecerla y volver a la normalidad.",
            }
        },
        //public:{
            buyActions:{
                frequencySwitcher:{
                    monthly: "al mes",
                    yearly: "al año",
                    quarterly: "al trimestre",
                    lifetime: "pago único",
                },
                giftCheckboxlabel: "Esto es un regalo.",
            },
            //not checkout modal being used through profile
            checkoutModal:{
                utrustAwaitingConfirmationParagraphFirst: "Estamos esperando la confirmación del pago por parte de xMoney.",
                utrustAwaitingConfirmationParagraphSecond: "Serás redirigido a tu perfil poco después de que se complete.",
                utrustAwaitingConfirmationParagraphThird: "También puedes cerrar esta ventana y volver más tarde para reclamar el NFT una vez confirmado el pago.",
                mbwayAwaitingConfirmationParagraphFirst: "Estamos esperando la confirmación de que tu pago se realizó correctamente.",
                mbwayAwaitingConfirmationParagraphSecond: "Abre tu aplicación MB WAY y confirma el pago allí.",
                lookingForRewardInstance: "Serás redirigido a tu perfil en breve.",
                processingOrder: "Estamos procesando tu pedido.",
                thankYouForPayment: "Gracias por tu pago",
                rewardInstanceNotFound: "Algo salió mal, haz clic AQUÍ para ser redirigido a tu perfil y contacta con el administrador de la colección.",
                finalAmountHigherThanZero: "Un solo usuario solo puede tener {{claimLimit}} instancias de este NFT. Por lo tanto, la cantidad de tu pedido se redujo de {{amount}} a {{finalAmount}}.",
                priceUpdated: "El precio de tu pedido también se ha actualizado a {{finalPrice}} {{currencySymbol}}.",
                orderStarted: "Tu pedido ha comenzado.",
                utrustIntro: "Serás o has sido redirigido al widget de pago de xMoney, compatible con cualquier cartera de criptomonedas principal. Sigue las instrucciones y confirma tu compra a continuación cuando todos los pasos estén completados.",
                utrustInstructions: "Si no has sido redirigido al widget de pago de xMoney, asegúrate de que tu navegador no esté bloqueando las ventanas emergentes de Membrz Club o ",
                changedMyMind: "Cambié de opinión",
                paymentComplete: "Completar pago",
                proceedToUtrust: "Llévame a xMoney",
                pay: "Pagar {{finalPrice}} {{currencySymbol}}",
                paymentProviderSelectorDescription: "Elige tu opción de pago preferida:",
                googlePayFailed: "Google Pay no está disponible. Elige un método de pago diferente.",
                giftBeingSent: "En breve te enviaremos un correo electrónico con los detalles de tu pedido y la confirmación de que tu regalo fue enviado.",
                inStock: "En stock. Suministro máximo: ",
                invoiceForm:{
                    description: "Añade tus datos a continuación.",
                },
                giftModal:{
                    title: "Regala este {{rewardCategoryLabel}} a alguien.",
                    description: "Añade un mensaje y los datos a continuación de a quién quieres regalar este {{rewardCategoryLabel}}. El {{rewardCategoryLabel}} se enviará por correo electrónico.",
                },
                giftForm:{
                    message: "Mensaje especial (máx. 400 caracteres)",
                    senderName: "Tu nombre",
                    senderEmail: "Tu correo electrónico",
                    name: "Nombre del destinatario",
                    email: "Correo electrónico del destinatario",
                },
           },
           profile:{
                sessionsCalendarCta: "Haz clic para ver todas las sesiones",
                eventCardSessions: "{{sessionsCount}} sesiones disponibles",
                eventCardSingleSession: "{{sessionsCount}} sesión disponible",
                unsubscribe: "Has iniciado sesión como: {{user_email}}. Confirma tu deseo de dejar de recibir boletines informativos de {{organization_title}} haciendo clic en el botón de abajo.",
                unsubscribeSuccess: "Preferencias actualizadas",
                events:{
                  pageDescription: "Ver todos los eventos",
                },
                perks:{
                    pendingApproval: "Solicitud recibida, pendiente de aprobación",
                    requestJoin: "Solicitar unirse",
                    noHiddenFees: "Sin cargos ocultos",
                    applicationFeesApply: "Se aplican tarifas de servicio",
                    productRedeemedSuccessfully: "¡Producto canjeado con éxito!",
                    ticketRedeemedSuccessfully: "¡Entrada canjeada con éxito!",
                    productRedeemedSuccessfullyDescription: "Gracias por canjear este producto. Nos pondremos en contacto en breve.",
                    ticketRedeemedSuccessfullyDescription: "Gracias por canjear esta entrada. Nos pondremos en contacto en breve.",
                    insuficientPointsMessage: "Necesitas {{points}} puntos para acceder a este producto. Puedes ganar una cantidad diferente de puntos mensualmente dependiendo de tu membresía.",
                    exclusivePerkMessage: "Exclusivo para suscriptores de {{tierTitles}}.",
                    saveUpToShort: "ahorran hasta un {{higher_discount_percentage}}%",
                    memberRateShort: "−{{discount_percentage}}% tarifa miembros.",
                    redeemedMaxShort: "Ya canjeado (máx.).",
                    redeemedOnceShort: "Canjeado una vez.",
                    redeemedNTimesShort: "Canjeado {{count}} veces.",
                    privatePerkMessage: "Abierto a todos los miembros.",
                    perTicket: "/ entrada",
                    redeemModal:{
                        rsvpStatementOfAction: "Estás a punto de confirmar tu asistencia a {{eventTitle}}.",
                        statementOfAction: "Estás a punto de canjear {{title}}.",
                        confirmationMessage: "¿Quieres continuar?",
                        reasonLabel: "Danos más detalles sobre por qué estás canjeando este beneficio.",
                        criteria:{
                            points: "Canjear este producto te costará {{points}} puntos. Actualmente tienes {{userPointsLabel}}.",
                            private: "Este producto es exclusivo para miembros.",
                            exclusive: "Este producto es exclusivo para miembros del siguiente nivel{{suffix}}: {{tierTitles}}.",
                            date: "Este producto caduca el {{formatedEndDate}}.",
                            supply: "Solo quedan {{available_amount}}.",
                        },
                    },
                    pageDescription: "Accede a beneficios exclusivos solo para miembros",
                },
                memberships:{
                    memberPageDescription: "Actualiza tu plan seleccionando otra opción de membresía",
                    pageDescription: "Selecciona la opción de membresía más adecuada para ti",
					paymentFrequency: {
                        monthly: "mes",
                        yearly: "año",
                        quarterly: "trimestre",
                        lifetime: "pago único",
                    },
                    claimModal:{
                      billingDetailsCTA: "Añadir datos de facturación",
                      ticketDetailsCTA: "Añadir información de la entrada",
                      singleTicketDescription: "Recibirás tu entrada en formato digital en el correo electrónico asociado a tu cuenta.\nEl día del evento, utiliza el código QR para entrar.\n\nSi no recibes la entrada en los próximos minutos, revisa tu carpeta de Spam.\n\nDespués de confirmar que la entrada no está en tu carpeta de Spam, contáctanos en hello@membrz.club y analizaremos la situación lo antes posible",
                      singleTicketAtTheDoorDescription:"También recibirás tu entrada en formato digital en el correo electrónico asociado a tu cuenta",
                      atTheDoorModalTitle: "¡Tu entrada{{suffix}}!",
                      atTheDoorModalDescription: "Gracias por tu compra. Muestra el código QR{{suffix}} de arriba para entrar al recinto.",
                      ticketDescription: "Información importante sobre tu entrada{{suffix}}",
                      multipleTicketDescription: "Recibirás todas las entradas en formato digital en el correo electrónico asociado a tu cuenta.\nAdemás, si deseas que las entradas se envíen a otras direcciones, haz clic en el botón de abajo.\n\nEl día del evento, utiliza el código QR para entrar.\n\nSi alguna de las entradas no se recibe en los próximos minutos, revisa la carpeta de Spam.\nDespués de confirmar que la entrada no ha sido marcada como Spam, contáctanos en hello@membrz.club y verificaremos la situación lo antes posible.\n\nPara añadir tus datos de facturación sin asociar otras direcciones de correo electrónico a esta compra, haz clic ",
                      multipleAtTheDoorTicketDescription: "También recibirás todas las entradas en formato digital en el correo electrónico asociado a tu cuenta.\nAdemás, si deseas que las entradas se envíen a otras direcciones, haz clic en el botón de abajo.\n\nPara añadir tus datos de facturación sin asociar otras direcciones de correo electrónico a esta compra, haz clic ",
                      upgradeSuccessfulMessage: "Tu suscripción ha sido actualizada",
                      upgradeConfirmationMessage: "Después de confirmar que deseas proceder con la actualización de tu suscripción, intentaremos cobrarte en los datos de tu tarjeta guardada. ¿Quieres continuar?",
                      thankYouForPayment: "¡Gracias por tu pago!",
                      ticketsSent: "Gracias. Entradas enviadas a las direcciones de correo electrónico solicitadas.",
                      welcomeToTheClub: "¡Bienvenido al club!",
                      back: "Atrás",
                      totalDue: "Total a pagar hoy",
                      renewalTimingsFrequency:{
                        monthly: "mensual",
                        yearly: "anual",
                        quarterly: "trimestral",
                      },
                      renewalTimings: "Pagarás {{itemPriceWithCurrency}} hoy, y luego {{translatedFrequency}} el {{day}}. Tu próximo cargo será el {{date}}.",
                      renewalTimingsSecond:"Esta suscripción se renueva automáticamente {{translatedFrequency}}, y se te notificará con antelación si el importe a pagar aumenta. Podrás cancelar tu suscripción en cualquier momento.",
                      invoiceFormDescription: "Añade tus datos a continuación.",
                      invoiceCreated: "Tu recibo ha sido creado y en breve se enviará una copia a tu correo electrónico. Puedes gestionar tus recibos ",
                      summary: {
                        monthly: "Pago mensual",
                        yearly: "Pago anual",
                        quarterly: "Pago trimestral",
                        lifetime: "Pago único",
                      },
                      buyNowWith: "Comprar ahora con",
                      processingMbWay_part1: "Valida la transacción en la aplicación MBWay o Bancaria",
                      processingMbWay_part2: "Haz clic en el botón para obtener tu",
                      processingBizum_part1: "Completa tu pago en la pestaña de pago de Bizum",
                      processingBizum_part2: "Si la pestaña de pago no se abrió, haz clic en el enlace de abajo",
                      processingBizum_part3: "Haz clic en el botón para obtener tu",
                      microsoftEmailWarningTitle1: "Pago exitoso!",
                      microsoftEmailWarningDescription1: "Tu entrada está en camino para el correo electrónico asociado a tu cuenta.",
                      microsoftEmailWarningTitle2: "IMPORTANTE – Hemos detectado que eres usuario de {{provider}}",
                      microsoftEmailWarningDescription2: "Estamos registrando algunos retrasos en la entrega de correos electrónicos para este proveedor.\nTranquilo, tu entrada puede tardar unos minutos más en llegar, pero definitivamente está en camino.\nDe todas formas, en la puerta del evento, podrás identificarte solo con tu correo electrónico.\n\nEn caso de duda, para validar tu compra o para enviarte directamente la entrada, contacta:\nhello@membrz.club",
                    },
                },
                sidebar:{
                    joinTheClub: "Únete al club",
                },
                about:{
                    privateElement: "Este enlace es privado solo para miembros de la comunidad. Por favor, hazte miembro primero.",
                    exclusiveElement: "Este enlace es privado para suscriptores del siguiente nivel{{suffix}}: {{tierTitles}}.",
                    brandingButton: "Crea un Membrz.Club Gratis",
                },
                connectModal:{
                    loggedInContent: "Conecta tu cartera y reclama tu pase de membresía.",
                    loggedOutContent: "Conecta tu cartera para crear una cuenta de MembrzClub y reclamar tu pase de membresía.",
                    step2Contnet: "Tu cuenta de MembrzClub ha sido creada. Proporciona una dirección de correo electrónico válida para concluir tu proceso de suscripción.",
                },
                freeSubscriptionModal:{
                    promptToSubscribe: "¿Te gusta lo que estás leyendo? No te pierdas ninguna actualización. ¡Unirse al club es tan fácil como escribir tu correo electrónico a continuación!",
                    emailPrompt: "Escribe tu correo electrónico...",
                    passwordPrompt: "Escribe tu contraseña...",
                    downgradingToFree: "Para bajar al nivel gratuito solo necesitas cancelar tu suscripción actual. Podrás disfrutar de todos sus beneficios hasta su fecha de caducidad. Una vez que la suscripción cancelada caduque, te moveremos al nivel seleccionado. Hasta entonces, podrás reactivar tu suscripción.",
                    agreement: "Al continuar, aceptas los"
                },
                repeatPurchaseModal:{
                    title: "Espera un momento ⏳",
                    descriptionFirst:{
                      part1: "Parece que ya has comprado este {{category}}",
                      part2: "y que tu última compra fue en la última hora.",
                      cart: "Parece que has realizado una compra para este evento en la última hora.",
                    },
                    descriptionSecond:{
                      ticket: "A veces, los correos electrónicos de confirmación de pedido y de entradas pueden tardar unos minutos en llegar, especialmente en momentos de mucho trabajo.",
                      product: "A veces, los correos electrónicos de confirmación de pedido pueden tardar unos minutos en llegar, especialmente en momentos de mucho trabajo.",
                    },
                    descriptionThird: "¿Confirmas que quieres proceder con una nueva compra?",
                    descriptionFourth:{
                      ticket: "Si no, revisa tu bandeja de entrada (y la carpeta de spam) para ver tu entrada y la confirmación del pedido o envíanos un mensaje a ",
                      product: "Si no, revisa tu bandeja de entrada (y la carpeta de spam) para ver la confirmación de tu pedido o envíanos un mensaje a ",
                    },
                },
            },
            publicReward:{
                //duplicated label
                shareMessage: "Compártelo con el mundo",
                addThisRewardMessage: "Añade este {{rewardCategoryLabel}} único a tu colección. Tarda menos de 1 minuto.",
            },
        //},
        student:{
            tickets:{
				pageTitle: "Entradas",
				pageDescription: "Aquí puedes ver y gestionar todas tus entradas",
				noneFoundMessage: "No se encontraron entradas",
				sendTicket: "Enviar entrada",
				detailsFormDescription: "Dinos el nombre y el correo electrónico de la persona a la que quieres enviar la entrada.",
				warning: "Al continuar, la entrada se enviará a la dirección de correo electrónico proporcionada. Ya no tendrás acceso a esta entrada.",
				sentSuccessfully: "Entrada enviada con éxito",
			},
            profile:{
                shareModalMessage: "Eres el nuevo propietario de",
            },
            onChainModal:{
                title: "¿Reclamar pase de membresía como NFT?",
                contentFirst: "Si tienes una cartera Web3 (como Metamask) puedes retirar tu pase de membresía, como un NFT en cadena.",
                contentSecond: "Esto te permitirá mostrar tu membresía en tu cartera y también tener acceso a aplicaciones Token-Gated en Membrz.Club",
                contentThird: "Si no tienes una ahora, ¡no te preocupes! Siempre puedes volver y asociar una cartera Web3 más tarde.",
                laterButtonLabel: "¡No, lo haré más tarde!",
            },
            orders:{
                pageTitle: "Pedidos",
                pageDescription: "Aquí puedes ver y gestionar todos tus pedidos",
                noneFoundMessage: "No se encontraron pedidos",
            },
            offers:{
                pageTitle: "Beneficios",
                pageDescription: "Aquí puedes ver todos los beneficios disponibles para ti",
                noOffers: "No hay beneficios disponibles en este momento",
                noOffersRedeemed: "Aún no has canjeado ningún beneficio",
                redeemedSuccessfullyMessage: "Has canjeado este beneficio con éxito.",
                redeemModal:{
                    firstLabel:'Estás a punto de canjear un beneficio por {{title}} por {{course}}.',
                    firstLabelExternal: 'Estás a punto de canjear un beneficio por {{title}}.',
                    secondLabel:'Al canjearlo, recibirás un correo electrónico con instrucciones sobre cómo activarlo en tu dirección de contacto asociada a Membrz Club.',
                    thirdLabel:'¿Confirmas que quieres canjear el beneficio?',
                    redeemButtomCancel: 'No. Quiero pensarlo un poco más.',

                },
            },
            preferredLanguage: "Elige tu idioma preferido",
            connectAccountModal:{
                title:{
                    telegram: 'Configurar nombre de usuario de Telegram',
                    whatsapp: 'Conectar tu cuenta de WhatsApp',
                },
                description:{
                    telegram: 'Por razones de seguridad, solo permitimos configurar el nombre de usuario de Telegram. Si aún no tienes uno, abre tu aplicación de Telegram, ve a Configuración y añádelo.',
                    whatsapp: 'Únete a grupos y comunidades exclusivos de WhatsApp añadiendo tu número de teléfono a continuación y vinculando tu cuenta de WhatsApp.',
                },
                inputLabel:{
                    telegram: 'Nombre de usuario de Telegram',
                    whatsapp: 'Número de teléfono',
                },
                showJoin: 'Para unirte a este grupo de Telegram, necesitas conectar tu cuenta de Telegram a tu cuenta de Membrz Club.'
            }
        },
        ui:{
            postCard:{
                commentPlaceholder: "Añadir un nuevo comentario",
                exclusive: "Este contenido solo está disponible para suscriptores premium de los siguientes niveles: {{tierTitles}}",
                privateOrFree: "Este contenido solo está disponible para miembros del club",
                becomeAMember: "Hazte miembro",
                becomeAFreeMember: "Únete gratis",
				becomeAPremiumMember: "Hazte Premium",
                becomeAMemberDescriptionFirst: "Necesitas ser miembro para interactuar con esta comunidad.",
				becomeAMemberDescriptionSecond: "¿Quieres hacerte uno ahora?",
            }
        },
        useSubscriptionController:{
            cancelSubscription: "Cancelar suscripción",
            reactivateSubscription: "Reactivar suscripción",
            cancelScheduledChange: "Cancelar cambio programado",
            updatePaymentDetails: "Actualizar datos de pago",
            confirmModalMessage:{
                mustReactivate: "Nos has pedido que cancelemos tu suscripción. Si quieres cambiar tu nivel, reactiva primero tu suscripción. ¿Quieres hacerlo ahora?",
                mustCancelDowngrade: "Tu suscripción está programada para bajar de categoría a {{futureRewardTitle}}. Si deseas cambiar la suscripción a la que estás bajando de categoría, cancela el cambio programado actualmente. ¿Quieres hacerlo ahora?",
                downgradetoFreeInstructions: "Para bajar al nivel gratuito solo necesitas cancelar tu suscripción actual. Podrás disfrutar de todos sus beneficios hasta su fecha de caducidad. Una vez que la suscripción cancelada caduque, te moveremos al nivel seleccionado. Hasta entonces, podrás reactivar tu suscripción. ¿Quieres continuar?",
                downgradeInstructions: "Al bajar de categoría a este nivel, cancelarás tu suscripción actual. Podrás disfrutar de todos sus beneficios hasta su fecha de caducidad. Una vez que la suscripción cancelada caduque, te moveremos al nivel seleccionado. Hasta entonces, podrás reactivar tu suscripción. ¿Quieres continuar?",
            },
            expiredSubscription: "Se intentarán nuevos cargos automáticamente.",
        },
        //___________________________________________________________________________________________________________________________________________________________________________________
        //components
        shippingForm:{
            title: "Dirección de envío",
            hint: "Este pedido será enviado — dinos a dónde mandarlo.",
            noExtraCosts: "El envío está incluido en el precio — no hay costes adicionales.",
            recipientName: "Nombre del destinatario",
        },
        authForms:{
            loginForm:{
                forgotPasswordQuestion: "¿Olvidaste tu contraseña?",
                forgotPasswordLink: "Restablécela aquí.",
                newToMembrzQuestion: "¿Nuevo en Membrz Club? ",
                signUpCall: "¡Regístrate ahora!",
            },
            resetForm:{
                successMessage: "Has restablecido tu contraseña con éxito. 🎉",
                claimingMessage: "Reclamando tu insignia ahora.",
                redirectMessage: "Redirigiendo a tu perfil.",
                resumingOrgSignupMessage: "Volviendo al registro de tu club.",
                requestInstructions: "Establecer contraseña y reclamar"
            },
            signUpForm:{
                alreadyRegisteredQuestion: "Si ya tienes una cuenta de Membrz Club, por favor ",
                signInCall: "inicia sesión aquí",
                defaultInstructions: "Proporciona tu dirección de correo electrónico para continuar.",
                storeInstructions: "Proporciona tu dirección de correo electrónico para continuar.",
                eventInstructions: "Usaremos este correo electrónico para enviar tu entrada.",
            },
            signUpOrganizationForm:{
                clubName: "Nombre del club",
                yourName: "Tu nombre",
                submitButton: "Crea tu Membrz.Club",
                existingAccountPrefix: "Ya existe una cuenta con este correo. Introduce tu contraseña para crear esta organización, o ",
                existingAccountResetLink: "restablece tu contraseña aquí",
                resumedFromResetMessage: "Introduce la contraseña para terminar de crear tu club.",
                passwordSetupPrefix: "Ya existe una cuenta con este correo. ",
                passwordSetupLink: "Haz clic aquí para establecer una contraseña y crear tu club",
            },
            authModal:{
                loginTitle: "¡Bienvenido de nuevo!",
                defaultSignUpTitle: "Información requerida",
                storeSignUpTitle: "Información requerida",
                eventSignUpTitle: "Información requerida",
            },
            common:{
                agreementDeclaration: "Acepto los Términos y Condiciones y la Política de Privacidad de Membrz Club",
            }
        },
        // not ui component. currently not being used? duplicated for easier deletion with component with not required
        offerCard:{
            externalEligibilityLabel: "Para canjear este beneficio necesitas poseer un {{rewardCategoryLabel}} con los siguientes atributos",
            internalElegilibityLabelReward: "Para canjear este beneficio necesitas poseer el siguiente {{rewardCategoryLabel}}",
            internalElegilibityLabelCourse: "Para canjear este beneficio necesitas poseer un {{rewardCategoryLabel}} de la siguiente organización:",
            offerRedeemedWith: "Has canjeado este beneficio con:",
            validatingRequestMessage: "Danos un momento para validar tu solicitud",
            awaitingConfirmationMessage: "Pronto nos pondremos en contacto contigo",
        },
        orderCard:{
            referenceNotFound: "Nº de referencia no encontrado",
        },
        // not ui component. currently not being used? duplicated for easier deletion with component if not required
        postCard:{
            lockedPost: "Este contenido solo está disponible para suscriptores de los siguientes niveles:",
        },
        // not claim model in use through profile. currently not being used? duplicated for easier deletion with component if not required
        claimModal:{
            upgradeSuccessfulMessage: "Tu suscripción ha sido actualizada",
            upgradeConfirmationMessage: "Después de confirmar que deseas proceder con la actualización de tu suscripción, intentaremos cobrarte en los datos de tu tarjeta guardada. ¿Quieres continuar?"
        },
        layouts:{
            public:{
                pagePrimaryDescription: "Membrz Club ayuda a marcas, organizaciones y creadores a conectar con su audiencia utilizando Coleccionables Digitales y NFTs.",
                pageSecondaryDescription: "¿Quieres saber más?",
                here: "Consúltalo aquí"
            },
        },
        rewardPreview:{
            metadata:{
                activityTitle: "Título de la colección",
                activityType: "Tipo de colección",
                claimedAt: "Reclamado el",
                issuedAt: "Emitido el",
                issuerName: "Nombre del emisor",
                tokenType: "Tipo de token",
            },
            onboarding:{
                onboardingSubtitleFirst: "Coleccionables de Membrz Club",
                onboardingTextFirst: "Los coleccionables de Membrz Club son regalos digitales exclusivos emitidos como NFTs, que celebran momentos, experiencias y logros únicos de la vida.",
                onboardingSubtitleSecond: "¿Nunca has oído hablar de los NFTs?",
                onboardingTextSecond: "Los NFT (Tokens No Fungibles) son tokens digitales únicos y verificables en la cadena de bloques. Pueden representar diferentes activos digitales, son de tu propiedad total y no se pueden falsificar. El proceso para reclamar un NFT con Membrz Club es simple y no se requiere experiencia en carteras o web3.",
            },
        },
        feedBackUser:{
            currentlyLoggedInAs: "Actualmente has iniciado sesión como", //suggestion: Currently logged in as
        },
        shareRewardModal:{
            defaultButton: "¡Visualiza y comparte tu {{rewardCategoryLabel}} aquí!",
            certificateButton: "¡Visualiza y comparte!",
            //duplicated label
            shareMessage: "Compártelo con el mundo",
        },
        utils:{
            copyToClipboard:{
                success: "¡Copiado al portapapeles!",
                failure: "¡Error al copiar! {{error}}",
            }
        },
        rewardType:{
            behaviour: "NFT",
            achievement: "Certificado",
            collectible: "Coleccionable",
            tier: "Nivel"
        },
		customFields:{
			"asa-perafita":{
				matricula: "Matrícula"
			},
			unicornfactorylisboa:{
				startup: "Startup"
			}
		},
		aiChat:{
			eventCreator:{
				title: "Asistente de creación de eventos",
				placeholder: "Describe tu evento...",
				collapsedPlaceholder: "Crea un evento con IA",
				initialMessage: "Cuéntame sobre tu evento. Por ejemplo: \"Concierto de Jazz el próximo viernes a las 20h en The Blue Note\""
			},
			ticketCreator:{
				title: "Asistente de creación de entradas",
				placeholder: "Describe tu categoría de entrada...",
				collapsedPlaceholder: "Crea entradas con IA"
			},
			labels:{
				start: "Inicio:",
				duration: "Duración:",
				location: "Ubicación:",
				capacity: "Capacidad:",
				description: "Descripción:",
				price: "Precio:",
                image: "Imagen",
			},
			buttons:{
				change: "Cambiar",
				create: "Crear",
				createAll: "Crear todos",
				startOver: "Reiniciar",
				upload: "Subir",
			},
			confirmation:{
				readyToCreate: "¿Estás listo para crear {{entityType}}?",
			},
			entities:{
				event: "evento",
				ticket: "entrada",
				tickets: "entradas"
			},
			formatters:{
				hour: "1 hora",
				hours: "{{count}} horas",
				minutes: "{{count}} minutos",
				attendees: "{{count}} participantes",
				free: "Gratis"
			},
			errors:{
				failedToSend: "Error al enviar mensaje",
				failedToCreate: "Error al crear {{entityType}}",
				failedToCreateRetry: "Error al crear {{entityType}}. Por favor, inténtalo de nuevo.",
				somethingWentWrong: "Algo salió mal. Por favor, inténtalo de nuevo."
			}
		}
    },
};

export { labels };
